var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCool = function SvgCool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.704 3.822a5.416 5.416 0 1 1 .785 10.762H8.333a1.25 1.25 0 0 1 0-2.5h14.190999999999999a2.918 2.918 0 0 0 1.168-5.612 2.917 2.917 0 0 0-3.898 1.832 1.25 1.25 0 0 1-2.388-.74 5.42 5.42 0 0 1 4.298-3.742M32.4 21.656c-.467-.276-1-.417-1.543-.406H5a1.25 1.25 0 0 1 0-2.5h25.822a5.417 5.417 0 1 1-5.083 7.02 1.25 1.25 0 1 1 2.388-.74 2.918 2.918 0 1 0 4.272-3.374"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.857 27.917a2.917 2.917 0 1 1-2.73 3.78 1.25 1.25 0 0 0-2.388.74 5.417 5.417 0 1 0 5.083-7.02H6.667a1.25 1.25 0 1 0 0 2.5h9.19"
  })));
};
export default SvgCool;